export default __webpack_public_path__ + "static/media/Directory.d27c4475.svg";